export * from './delete-kunden-art.component';
export * from './delete-kunden-art.component.module';